import { Injectable } from '@angular/core';
import { UserSettingsStorage } from '@storage/settings/user-settings.storage';
import { ConfigsStorage } from '@storage/configs.storage';

@Injectable({
    providedIn: 'root'
})
export class BannerService {

    constructor(
        private configsStorage: ConfigsStorage,
        private settingsStorage: UserSettingsStorage
    ) { }


    isBannerSeen(): boolean {
        if (!this.configsStorage.config.WEB_BANNER_KEY) {
            return true;
        }
        return this.settingsStorage.isBannerSeen(this.configsStorage.config.WEB_BANNER_KEY);
    }

    setIsBannerSeen(): void {
        this.settingsStorage.setIsBannerSeen(this.configsStorage.config.WEB_BANNER_KEY);
    }
}